import React from 'react'
import SliderCarousel from '../components/SliderCarouselsingle'
import Footer from '../components/footer'
import { createGlobalStyle } from 'styled-components'
import Reveal from 'react-awesome-reveal'
import { keyframes } from '@emotion/react'
import { requestReleaseMyToken } from '../data'

const fadeInUp = keyframes`
  0% {
    opacity: 0;
    -webkit-transform: translateY(40px);
    transform: translateY(40px);
  }
  100% {
    opacity: 1;
    -webkit-transform: translateY(0);
    transform: translateY(0);
  }
`

const GlobalStyles = createGlobalStyle`
  header#myHeader.navbar.sticky.white {
    background: #212428;
    border-bottom: 0;
    box-shadow: 0 4px 20px 0 rgba(10,10,10, .8);
  }
  header#myHeader.navbar .search #quick_search{
    color: #fff;
    background: rgba(255, 255, 255, .1);
  }
  header#myHeader.navbar.white .btn, .navbar.white a, .navbar.sticky.white a{
    color: #fff;
  }
  header#myHeader .dropdown-toggle::after{
    color: #fff;
  }
  header#myHeader .logo .d-block{
    display: none !important;
  }
  header#myHeader .logo .d-none{
    display: none !important;
  }
  header#myHeader .logo .d-3{
    display: block !important;
  }
  .jumbotron.no-bg{
    background: center bottom;
    background-size: cover;
    height: 100vh;
  }
  footer.footer-light .subfooter span img.d-1{
    display: none !important;
  }
  footer.footer-light .subfooter span img.d-3{
    display: inline-block !important;
  }
  .de_countdown{
    right: 10px;
    color: #fff;
  }
  .author_list_pp{
    margin-left:0;
  }
  footer.footer-light .subfooter{
    border-top: 1px solid rgba(255,255,255,.1);
  }
`

const requesMyToken = async () => {
  try {
    requestReleaseMyToken()
  } catch (error) {
    console.log(error.message)
  }
}

const homethree = () => (

  <div>
    <GlobalStyles />
    <section
      className="jumbotron no-bg"
      style={{ backgroundImage: `url(${'./img/background/7.jpg'})` }}
    >
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-6">
            <div className="spacer-single"></div>
            <Reveal
              className="onStep"
              keyframes={fadeInUp}
              delay={0}
              duration={600}
              triggerOnce
            >
              <h6 className="">
                <span className="text-uppercase color">AFER Token Seed Sale.</span>
              </h6>
            </Reveal>
            <div className="spacer-10"></div>
            <Reveal
              className="onStep"
              keyframes={fadeInUp}
              delay={300}
              duration={600}
              triggerOnce
            >
              <h1 className="">AFER</h1>
            </Reveal>
            <Reveal
              className="onStep"
              keyframes={fadeInUp}
              delay={600}
              duration={600}
              triggerOnce
            >
              <p className=" lead">
              Monitor the events of the seed sale and request for your AFER token when the time is right!
              </p>
            </Reveal>
            <div className="spacer-10"></div>
            <Reveal
              className="onStep"
              keyframes={fadeInUp}
              delay={800}
              duration={900}
              triggerOnce
            >
              <span
                onClick={() => requesMyToken()}
                className="btn-main lead"
              >
                Request My Tokens
              </span>
              <br/>
              <div className="mb-sm-30"></div>
            </Reveal>
            <div className="spacer-double"></div>
          </div>
          <div className="col-lg-6 px-0">
            <SliderCarousel />
          </div>
        </div>
      </div>
    </section>

    <div className="clearfix"></div>  
    <div className="spacer-single"></div>

    <div className="col-lg-12">
      <Footer/>
  </div>
    
  </div>
)
export default homethree
